import React from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface RegisteredAddressScreenProps {
  address: string;
  city: string;
  state: string;
  zipCode: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function RegisteredAddressScreen({
  address,
  city,
  state,
  zipCode,
  onChange,
  onNext,
  onBack
}: RegisteredAddressScreenProps) {
  const isValid = address.trim().length > 0 && city.trim().length > 0 && state.trim().length > 0 && zipCode.trim().length > 0;
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-256">
      <div className="flex-1" data-id="element-257">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-258">
          Registered Address
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-259">
          Enter the official registered address of your business.
        </p>

        <div className="space-y-6" data-id="element-260">
          <Input label="Street Address" placeholder="e.g. 123 Business Park" value={address} onChange={e => onChange('registeredAddress', e.target.value)} autoFocus data-id="element-261" />
          <div className="grid grid-cols-2 gap-4" data-id="element-262">
            <Input label="City" placeholder="e.g. New York" value={city} onChange={e => onChange('registeredCity', e.target.value)} data-id="element-263" />
            <Input label="State" placeholder="e.g. NY" value={state} onChange={e => onChange('registeredState', e.target.value)} data-id="element-264" />
          </div>
          <Input label="Zip Code" placeholder="e.g. 10001" value={zipCode} onChange={e => onChange('registeredZip', e.target.value)} data-id="element-265" />
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-266">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-267">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-268">
          Continue
        </Button>
      </div>
    </div>;
}